export default __webpack_public_path__ + "media/images/icons/arrow-next-2-3fc5d03c95c0c20c99fcaafac034bd33.svg";